import { indexedDBService } from "../../../common/utils/indexedDB";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { PersonInfoInterface } from "../../../common/interfaces/PersonInfoInterface";

interface Props {
    personInfo: PersonInfoInterface;
    navigate: (route: string) => void;
}

export const handleSkipAndExit = async (props: Props): Promise<void> => {
    const { personInfo, navigate } = props;

    try {
        const emptyVoteData = {
            choice: personInfo?.choice || "",
            name: "",
            email: "",
            company: "",
            agreeOnTerms: false,
            timestamp: Date.now(),
        };

        await indexedDBService.saveData(
            `vote_${Date.now()}`,
            emptyVoteData,
            false,
        );

        navigate(RouteEnum.CHOICE_SELECTION);
    } catch (error) {
        console.error("Failed to save empty vote data:", error);
    }
};
